<template>
  <AssetCheckList />
</template>
<script route="/exec/assets/check_list">
  import AssetCheckList from './asset_check_list.jsx'
  export default {
    components: {
      AssetCheckList
    }
  }
</script>